import React from 'react';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import * as styles from './PhotoPersonalisationMessage.styles';

const trackLinkClick = (ev: React.MouseEvent<HTMLAnchorElement>) => {
  sendGALinkClickEvent(ev, {
    event: 'custom_event_v2',
    event_name: 'select_content',
    event_details: 'link click',
    content_type: 'delivery information',
    item_id: 'learn more about photo personalisation',
  });
};

export const PhotoPersonalisationMessage = () => {
  return (
    <div>
      <h4 css={styles.heading}>Photo personalisation</h4>
      <p css={styles.content}>
        Please upload your photos on the same day of purchase. Delays may affect the estimated
        delivery date.
      </p>
      <p css={styles.content}>
        <a
          css={styles.accentLink}
          href="https://info.notonthehighstreet.com/hc/en-us/articles/360002304834-How-do-I-upload-photos-for-my-order"
          onClick={trackLinkClick}
          rel="noreferrer"
          target="_blank"
        >
          Learn more
        </a>
      </p>
    </div>
  );
};
